import { useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

import NotFoundImage from '~/assets/images/error/not-found.png';
import FooterPublic from '~/components/organisms/FooterPublic/FooterPublic';
import HeaderPublic from '~/components/organisms/HeaderPublic/HeaderPublic';
import { cookieService } from '~/services/cookie-service';
import { useErrorsStore } from '~/store/useErrorStore';
import { COLORS } from '~/styles/colors';

export function NotFound() {
  const isAccessCookie = cookieService.getCookie('access') || null;
  const theme = useTheme();
  const { setIsOn404 } = useErrorsStore();

  useEffect(() => {
    setIsOn404(true);
    return () => {
      setIsOn404(false);
    };
  }, []);

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'auto',
      }}
    >
      {!isAccessCookie && <HeaderPublic />}
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${NotFoundImage})`,
          backgroundColor: COLORS.darkBlue2,
          minHeight: '375px',
          paddingTop: '76px',
          paddingLeft: '16px',
          overflow: 'hidden',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'bottom',
          [theme.breakpoints.up('sm')]: {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          },
          [theme.breakpoints.up('lg')]: {
            minHeight: '778px',
            paddingTop: '154px',
            paddingLeft: '83px',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '38px',
            fontWeight: 700,
            color: COLORS.white,
            textAlign: 'center',
            [theme.breakpoints.up('md')]: {
              fontSize: '60px',
              textAlign: 'left',
            },
          }}
        >
          Ooooppsss...
        </Typography>
        <Typography
          sx={{
            fontSize: '30px',
            fontWeight: 700,
            color: COLORS.white,
            textAlign: 'center',
            [theme.breakpoints.up('md')]: {
              fontSize: '46px',
              textAlign: 'left',
            },
          }}
        >
          404 page not found
        </Typography>
      </Box>
      <FooterPublic />
    </Box>
  );
}
